/**
 * Currency Formatter Component
 * Displays amounts with proper currency formatting (Indian Rupees)
 */

interface CurrencyFormatterProps {
  amount: number;
  currency?: string;
  className?: string;
  showSymbol?: boolean;
}

export const CurrencyFormatter = ({
  amount,
  currency = 'INR',
  className = '',
  showSymbol = true,
}: CurrencyFormatterProps) => {
  const formattedAmount = new Intl.NumberFormat('en-IN', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return <span className={className}>{formattedAmount}</span>;
};

/**
 * Utility function to format currency as string
 */
export const formatCurrency = (
  amount: number,
  currency: string = 'INR',
  showSymbol: boolean = true
): string => {
  return new Intl.NumberFormat('en-IN', {
    style: showSymbol ? 'currency' : 'decimal',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
